import { pr, theme, ui } from "aaa";
import { SettingsButton } from "components/loginManagement/components/SettingsButton";
import { themeColors } from "muiTheme";
import * as React from "react";

type UserNumberCardProps = {
    value: string;
    onCopy: () => void;
};

export const UserNumberCard = ({ value, onCopy }: UserNumberCardProps) => (
    <SettingsButton
        icon={<pr.IconUser style={{ color: themeColors.georgeBlue }} />}
        border="none"
        borderRadius="both"
        onClick={onCopy}
        style={{ backgroundColor: ui.isDarkMode ? themeColors.d_grey_300 : "white", marginBottom: theme.MARGIN }}
    >
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
            <pr.P_16_CONTENT
                style={{
                    flex: 1,
                    margin: 0,
                    color: ui.isDarkMode ? "white" : themeColors.george_text_color,
                    fontWeight: 500,
                }}
            >
                {value}
            </pr.P_16_CONTENT>
            <pr.IconCopy2 style={{ color: themeColors.georgeBlue }} />
        </div>
    </SettingsButton>
);



// WEBPACK FOOTER //
// ./src/components/gJunior/components/cards/UserNumberCard.tsx